/* eslint-disable */

import React, { Suspense, useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import $ from "jquery";
import { updateState, selectMedium } from "../counter/counterSlice";
import * as searchStore from "../../store/reducers/search";
import NoResults from "./noResults";
import Paging from "./paging";
import RefineSearch from "./refineSearch";
import SortResults from "./sortResults";
import useTopicFunctions from "../../hooks/useTopicFunctions.js";
import { performDrugSearch } from "../../components/drugIndexModalSearch.util.js";
import { SearchTGSynonyms, XPathSynonyms } from "./search.util.js";
import { useLocation, useNavigate } from "react-router-dom";

const NavBar = React.lazy(() => import("../../components/navBar"));
const SearchResultsTopics = React.lazy(() => import("./searchResultsTopics"));
const SearchResultsDrugs = React.lazy(() => import("./searchResultsDrugs"));
const SearchResultsAll = React.lazy(() => import("./searchResultsAll"));
const TopicBanner = React.lazy(() => import("../../components/topicBanner"));
const TopicToolsSticky = React.lazy(() =>
  import("../../components/topicToolsSticky")
);
const Footer = React.lazy(() => import("../../components/footer"));
const SavedSearchModal = React.lazy(() =>
  import("../../components/savedSearchModal")
);

let tgg = window.tgg;
let defiant = window.defiant;
let getURL = window.location.href;

const intVariable = 1000;

$(window).on("resize", function () {
  let sliderCheck = $("#tgsearch .slider-arrow");
  if ($(sliderCheck).hasClass("show")) {
    if ($(window).width() <= 315) {
      $(sliderCheck).css("left", "198px");
    } else {
      $(sliderCheck).css("left", "290px");
    }
  }
});

$(document).on("click", "#tgsearch .slider-arrow", function (e) {
  if ($(this).hasClass("show")) {
    if (screen.width <= 315) {
      $("#sidemenu-container").animate(
        {
          left: "-198px",
        },
        700,
        function () {
          // Animation complete.
          console.log("Guideline hide");
        }
      );
    } else {
      $("#sidemenu-container").animate(
        {
          left: "-345px",
        },
        700,
        function () {
          // Animation complete.
          console.log("Guideline hide");
        },
      );
    }

    $("#tgsearch .slider-arrow").animate(
      {
        left: "0",
      },
      700,
      function () {
        // Animation complete.
        console.log("Slider minimized");
      }
    );
    $(this).removeClass("show").addClass("hide");
  } else {
    $("#sidemenu-container").animate(
      {
        left: "0px",
      },
      700,
      function () {
        // Animation complete.
        console.log("Guideline show");
      }
    );
    if (screen.width <= 315) {
      $("#tgsearch .slider-arrow").animate(
        {
          left: "198px",
        },
        700,
        function () {
          // Animation complete.
          console.log("Slider show");
        }
      );
    } else {
      $("#tgsearch .slider-arrow").animate(
        {
          left: "290px",
        },
        700,
        function () {
          // Animation complete.
          console.log("Slider show");
        }
      );
    }
    $(this).removeClass("hide").addClass("show");
  }
  e.stopPropagation();
});

const Search = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const pathname = location.pathname;
  const search = location.search;
  const { displaySearch } = useTopicFunctions();
  const dispatch = useDispatch();
  const resultItemRefs = useRef([]);
  const searchIndex = useSelector(searchStore.selectSearchIndex);
  const searchTerm = useSelector(searchStore.selectSearchTerm);
  const refineIndex = useSelector(searchStore.selectRefineIndex);
  const searchAllResults = useSelector(searchStore.selectAllResults);
  const searchTopicsResults = useSelector(searchStore.selectTopicResults);
  const searchDrugResults = useSelector(searchStore.selectDrugResults);
  const searchFacets = useSelector(searchStore.selectFacets);
  const refineFacet = useSelector(searchStore.selectRefineFacet);
  const paginatePage = useSelector(searchStore.selectPaginatePage);

  const [facetAllResults, setFacetAllResults] = useState("");
  const [facetTopicResults, setFacetTopicResults] = useState("");
  const [facetDrugResults, setFacetDrugResults] = useState("");
  const [allKeywords, setAllKeywords] = useState("");
  const [sortResults, setSortResults] = useState(0);

  const [withinSearchVal, setWithinSearchVal] = useState("");
  const [homeLinkClass, setHomeLinkClass] = useState("");
  const [drugLinkClass, setDrugLinkClass] = useState("");
  const [menuLinkClass, setMenuLinkClass] = useState("");
  const [searchingTabClass, setSearchingTabClass] = useState("active");
  const [homeTabClass, setHomeTabClass] = useState("");
  const [menuTabClass, setMenuTabClass] = useState("");
  const [drugTabClass, setDrugTabClass] = useState("");
  const [gSnapshot, setGSnapshot] = useState(0);
  const [tSnapshot, setTSnapshot] = useState(0);
  const [snapshotReady, setSnapshotReady] = useState(0);

  const [drugTabShow, setDrugTabShow] = useState(true);
  const [shouldGoBack, setShouldGoBack] = useState(false);

  const glOnClickHandler = (glName) => {
    dispatch(searchStore.setRefineFacet(glName));

    const newURL = `${window.location.href}&guideline=${encodeURIComponent(
      glName
    )}`;
    window.history.replaceState(null, null, newURL);
  };

  const getTopicTitle = (topicId) => {
    try {
      return findNestedObj(tgg.topics, "i", topicId).s;
    } catch (error) {
      return "-Topic Title-";
    }
  };

  const GetTitleGuideline = (titleId) => {
    // console.log(titleId);
    const titlePath = findPath(tgg.topics, "i", titleId.i);
    // console.log(titlePath);
    return { g: titlePath[0] };
  };

  const getTitlePath = (titleId) => {
    // console.log(titleId);
    const titlePath = findPath(tgg.topics, "i", titleId);
    // console.log(titlePath);
    return titlePath[1];
  };

  const GetTggGuideline = (val) => {
    const guidelinePath = findPath(tgg.guidelines, "i", val.i);
    return { g: guidelinePath[0] };
  };

  function findNestedObj(obj, key, val) {
    if (obj[key] === val) {
      return obj;
    }

    for (let k in obj) {
      if (obj.hasOwnProperty(k) && typeof obj[k] === "object") {
        let nestedObj = findNestedObj(obj[k], key, val);
        if (nestedObj) {
          return nestedObj;
        }
      }
    }

    return null;
  }

  function findPath(obj, key, val, path = []) {
    if (obj[key] === val) {
      return path.concat(key);
    }

    for (let k in obj) {
      if (obj.hasOwnProperty(k) && typeof obj[k] === "object") {
        let nestedPath = findPath(obj[k], key, val, path.concat(k));
        if (nestedPath) {
          return nestedPath;
        }
      }
    }

    return null;
  }

  const getGuidelinesFacet = async (facets, caller = "unknown") => {
    console.time("buildFacets-" + caller);
    const facetContent = [];
    // console.log(facets);
    if (facets.guideline) {
      let newArr = [];
      //   const facets = {guideline:{}};
      //   results.map((result) => {
      //     const group = result.g;
      //     if (!facets.guideline[group]) {
      //       facets.guideline[group] = 0;
      //     }
      //     facets.guideline[group]++;
      //   });

      newArr = Object.fromEntries(
        //sort facet based on the number of results per guideline
        Object.entries(facets.guideline).sort(function (a, b) {
          return b[1] - a[1];
        })
      );
      let facetArray = Object.entries(newArr);
      // facetArray = facetArray.filter(item => item[0] !=="Other");
      // console.log(facetArray);

      facetArray.map((_, firstIdx) => {
        let content = facetArray[firstIdx].map((_, secondIdx) => {
          if (secondIdx !== 1) {
            const glName = facetArray[firstIdx][secondIdx].replace(/_/g, " ");
            // console.log(glName);
            const propStr = glName.toLowerCase();
            return (
              <span key={firstIdx + secondIdx} className="facet-item">
                <span className={`dotIcon ${propStr.replace(/ /g, "")}`}></span>
                <a
                  href="#"
                  className="guidelineTitleForFilterSearch gl-value"
                  onClick={() => glOnClickHandler(glName)}
                >
                  <span className="gl-text">{glName}</span>
                </a>
              </span>
            );
          } else {
            return (
              <span className="facet-item-count" key={firstIdx + secondIdx}>
                {" "}
                <strong className="marginLeft3px badge">
                  {facetArray[firstIdx][secondIdx]}
                </strong>
              </span>
            );
          }
        });

        return facetContent.push(
          <li key={firstIdx} data-key={firstIdx} className="facet-group">
            {content}
          </li>
        );
      });
    } else {
      facetContent.push(<li key={0} data-key={0} className="facet-group"></li>);
    }

    // setFacetContentHTML(facetContent);
    // console.log(facetContent);
    console.timeEnd("buildFacets-" + caller);
    return facetContent;
  };

  const PaginateMenu = () => {
    // const searchIndex = localStorage.getItem('headerSearch').trim();
    const checkGuideline = localStorage.getItem("selectedGuideline");
    const newSearchParams = new URLSearchParams(window.location.search);
    let topicURL = "";
    setSearchingTabClass("");
    setHomeLinkClass("");
    setDrugLinkClass("");
    setMenuLinkClass("activecount");
    setHomeTabClass("");
    setMenuTabClass("active");
    setDrugTabClass("");

    if (newSearchParams.has("guideline"))
      topicURL = `?appendedinputbuttons=${searchIndex}&guideline=${checkGuideline}#topic`;
    else topicURL = `?appendedinputbuttons=${searchIndex}#topic`;
    window.history.replaceState(null, null, topicURL);
  };

  const PaginateHome = () => {
    setSearchingTabClass("");
    setHomeLinkClass("activecount");
    setDrugLinkClass("");
    setMenuLinkClass("");
    setHomeTabClass("active");
    setMenuTabClass("");
    setDrugTabClass("");
  };

  const PaginateSearch = () => {
    $(".loader").fadeIn("fast");
    setSearchingTabClass("active");
    setHomeLinkClass("");
    setDrugLinkClass("");
    setMenuLinkClass("");
    setHomeTabClass("");
    setMenuTabClass("");
    setDrugTabClass("");

    if (searchTerm.length === 0) {
      $(".loader").fadeOut("fast");
    }
  };

  const PaginateDrug = () => {
    let topicURL;
    // const searchIndex = localStorage.getItem('headerSearch').trim();
    const checkGuideline = localStorage.getItem("selectedGuideline");
    const newSearchParams = new URLSearchParams(window.location.search);
    setSearchingTabClass("");
    setHomeLinkClass("");
    setDrugLinkClass("activecount");
    setMenuLinkClass("");
    setHomeTabClass("");
    setMenuTabClass("");
    setDrugTabClass("active");
    if (newSearchParams.has("guideline"))
      topicURL = `?appendedinputbuttons=${encodeURIComponent(
        searchIndex
      )}&guideline=${checkGuideline}#drugindication`;
    else
      topicURL = `?appendedinputbuttons=${encodeURIComponent(
        searchIndex
      )}#drugindication`;
    window.history.replaceState(null, null, topicURL);
  };

  const pluralize = (word) => {
    if (word.match(/(s|x|z|ch|sh)$/i)) {
      return word + "es";
    } else if (word.match(/[^aeiou]y$/i)) {
      return word.replace(/y$/i, "ies");
    } else {
      return word + "s";
    }
  };

  const singularize = (word) => {
    if (word.match(/(s|x|z|ch|sh)es$/i)) {
      return word.replace(/es$/i, "");
    } else if (word.match(/[^aeiou]ies$/i)) {
      return word.replace(/ies$/i, "y");
    } else {
      return word.replace(/s$/i, "");
    }
  };

  const removeStopWords = (query) => {
    const stopWords = [
      "a",
      "about",
      "above",
      "after",
      "again",
      "against",
      "ain",
      "all",
      "am",
      "an",
      "and",
      "any",
      "are",
      "aren",
      "aren't",
      "as",
      "at",
      "be",
      "because",
      "been",
      "before",
      "being",
      "below",
      "between",
      "both",
      "but",
      "by",
      "can",
      "couldn",
      "couldn't",
      "d",
      "did",
      "didn",
      "didn't",
      "do",
      "does",
      "doesn",
      "doesn't",
      "doing",
      "don",
      "don't",
      "down",
      "during",
    ];
    const words = query
      .split(" ")
      .filter((word) => !stopWords.includes(word.toLowerCase()));
    return words.join(" ");
  };

  const XPathXpress = (
    flattenedKeywords,
    synIndex,
    topicSearchResults = true
  ) => {
    // const treatedWords = flattenedKeywords.map((word)=>{
    //   return `((contains(|key|, "${pluralize(word)}") or contains(|key|, "${singularize(word)}"))`;
    // });
    // const batchWords = `(${treatedWords.join(') and (')}))`;
    // console.log(batchWords,flattenedKeywords);

    // no need to pluralize.... since defiant uses contains and would find es and s... we need to singularize though... TBD...

    const treatedWords = flattenedKeywords.map((word) => {
      return `contains(|key|, "${word}")`;
    });
    const batchWords = `${treatedWords.join(" and ")}`;
    // console.log(batchWords,flattenedKeywords);

    const searchKeys = ["s"];

    const batchXpression = searchKeys.map((searchKey, index) => {
      return `${batchWords.replace(/\|key\|/g, searchKey)}`;
    });

    if (!topicSearchResults) {
      const expressions = flattenedKeywords.map(
        (word) => `contains(d, "${word}")`
      );
      const drugXpress = `//*[${expressions.join(" and ")}]`
        .replace(/\/\/\*\[/g, "(")
        .replace(/\)\]/g, "))");
      batchXpression.push(drugXpress);
      // console.log(topicSearchResults,batchXpression,drugXpress);
    }

    const combinedBatchExpression = `${batchXpression.join(" or ")}`;
    // console.log(topicSearchResults,combinedBatchExpression);

    return `//*[${combinedBatchExpression}]`;
  };

  const SearchTGDrugs = (obj, searchValue, synIndex) => {
    // NOT USED with xPath
    const drugResults = [];
    const keywords = searchValue.toLowerCase().split(" ");
    synIndex.map((index) => {
      const synonyms = tgg.synonyms.rows[index][0].toLowerCase().split(", ");
      keywords.push(...synonyms);
      // keywords.push('aspirin');
    });

    const flattenedKeywords = [].concat(...keywords);
    for (const key in obj) {
      // console.log(key);
      if (typeof obj[key] === "object" && key !== "d") {
        const nestedResults = SearchTGDrugs(obj[key], searchValue, synIndex);
        drugResults.push(...nestedResults);
      } else if (key === "d") {
        for (const drug in obj[key]) {
          const drugValue = obj[key][drug]
            .toString()
            .split(" - ")[0]
            .toLowerCase();
          const drugWordCount = flattenedKeywords.filter((keyword) =>
            drugValue.includes(keyword)
          );
          if (drugWordCount.length > 0) {
            drugResults.push(obj);
          } else {
            delete obj[key][drug];
          }
        }
      }
    }
    return drugResults;
  };

  const SortByResults = (dispatch, searchStore, results) => {
    let sortBy = parseInt(sortResults);

    Object.keys(results).map((key) => {
      if (sortBy === 0) {
        sortBy = 1;
      }
      switch (sortBy) {
        case 0: {
          results[key].sort((a, b) => {
            return a.r.to < b.r.to ? 1 : -1;
          });

          break;
        }
        case 1: {
          results[key].sort((a, b) => {
            let aValue = a.s;
            let bValue = b.s;
            if (key === "drugs") {
              aValue = a.d;
              bValue = b.d;
            }
            return bValue < aValue ? 1 : -1;
          });
          break;
        }
        case 2: {
          results[key].sort((a, b) => {
            let aValue = a.s;
            let bValue = b.s;
            if (key === "drugs") {
              aValue = a.d;
              bValue = b.d;
            }
            return aValue < bValue ? 1 : -1;
          });
          break;
        }
      }
    });

    // console.log(results);
    dispatch(
      searchStore.setResults({
        allResults: results.all,
        topicResults: results.topics,
        drugResults: results.drugs,
      })
    );
    return results;
  };

  const SearchXPath = async (
    searchIndex,
    synIndex,
    topicSearchResults = true
  ) => {
    console.time(">>>SearchXPath" + (topicSearchResults ? "-topic" : "-all"));
    // console.log(searchIndex);
    const searchKeyword =
      searchIndex.charAt(searchIndex.length - 1) === "*"
        ? searchIndex.slice(0, -1)
        : searchIndex;
    const keywords = removeStopWords(searchKeyword)
      .toLowerCase()
      .split(" ")
      .map((word) => [word]);
    // TODO: add singularize and pluralize...
    const rScores = { d: 15, s: 10, t: 5, k: 3, g: 1 };
    let flattenedKeywords = [].concat(...keywords);
    let xPathXpress = "//*[]";
    if (searchIndex.length >= 3)
      xPathXpress = XPathXpress(
        flattenedKeywords,
        synIndex,
        topicSearchResults
      );
    // console.log(xPathXpress);
    const kXPress = XPathSynonyms(synIndex);
    if (kXPress.length > 0) {
      if (searchIndex.length >= 4) {
        xPathXpress = xPathXpress.replace("]", kXPress + "]");
      } else {
        xPathXpress = `//*[${kXPress.replace(" or c", "c")}]`;
      }
      // xPathXpress = `//*[${kXPress.replace(" or c","c")}]`;
    }
    // console.log(((topicSearchResults)?"Topics:":"All:")+xPathXpress);
    let searchSnapshot = topicSearchResults ? tSnapshot : gSnapshot;
    let refineTag = "";
    if (refineIndex.length > 0) {
      searchSnapshot = topicSearchResults
        ? searchTopicsResults
        : searchAllResults;
      refineTag = "-refined";
    }
    // if(refineIndex.length > 0) {
    //   debugger;
    // }
    // console.log(refineTag,searchSnapshot);
    console.time(
      (topicSearchResults ? "Topic" : "All") + ":defiantSearch" + refineTag
    );
    const tResults = defiant.search(searchSnapshot, xPathXpress);
    console.timeEnd(
      (topicSearchResults ? "Topic" : "All") + ":defiantSearch" + refineTag
    );
    // console.log(xPathXpress,tResults);
    let searchItems = xPathXpress.split("contains(");
    let isKOnly = false;
    if (searchItems.length > 1) {
      if (
        (searchItems[1].indexOf("k") === 0 && !topicSearchResults) ||
        (sortResults !== 0 && !topicSearchResults)
      ) {
        // 0 is sort by relevance.
        isKOnly = true;
      }
    }
    // console.log(searchItems[1]);
    if (refineIndex.length > 0 || isKOnly) {
      // console.log(tResults);
      return tResults;
    }

    // console.log("tResults",tResults,xPathXpress);
    flattenedKeywords.push(...synIndex);
    // console.log("flattenedKeywords",flattenedKeywords);
    const matchResults = JSON.parse(JSON.stringify(tResults)) // copy object
      .filter((result) => {
        if (result.g === undefined) {
          if (result.t !== undefined) {
            result.g = GetTggGuideline(result).g.replace(/_/g, " ");
          } else {
            result.g = GetTitleGuideline(result).g.replace(/_/g, " ");
          }
        }

        let tValue = "";
        if (result.t !== undefined) {
          tValue = getTopicTitle(result.t).toLowerCase();
          result.t =
            getTopicTitle(result.t) +
            "|" +
            result.t +
            "|" +
            getTitlePath(result.t);
          // console.log(result.t);
        }

        let dValue = "";
        if (result.d !== undefined) {
          result.d = dValue = JSON.stringify(result.d).toLowerCase();
        }

        const sValue = (result.s || "").toLowerCase();
        const gValue = (result.g || "").toLowerCase();
        const kValue = (result.k || "").toLowerCase().replace(/,/g, " ");
        const stemValue =
          searchIndex.charAt(searchIndex.length - 1) === "*" ? true : false;
        // console.log("stemValue",stemValue);
        return flattenedKeywords.some((word) => {
          // console.log(word);
          word = word.toString().toLowerCase();
          const regex = new RegExp(`\\b${word}\\b`, "i");
          if (
            regex.test(sValue) ||
            regex.test(dValue) ||
            regex.test(kValue) ||
            regex.test(tValue) ||
            regex.test(gValue) ||
            stemValue
          ) {
            if (!result.r && !topicSearchResults) {
              result.r = { to: 0, d: 0, s: 0, t: 0, k: 0, g: 0 };
            }
            // console.log(JSON.stringify(result));
            Object.keys(result).map((key) => {
              // console.log(key,result[key]);
              if (
                result[key] !== "" &&
                result[key] !== undefined &&
                result[key] !== null &&
                !topicSearchResults &&
                !["i", "r", "k"].includes(key)
              ) {
                // console.log(result,key,result[key],word,result[key].indexOf(word));

                const keywordIndex = result[key].toLowerCase().indexOf(word);
                const percentage =
                  keywordIndex === 0
                    ? 100
                    : keywordIndex > 0
                    ? Math.round((1 - keywordIndex / result[key].length) * 100)
                    : 0;
                result.r[key] = (rScores[key] * percentage) / 100;
                result.r.to += result.r[key];
                // console.log("key,[result[key],result.r,result.r[key]]",key,result[key],result.r,result.r[key]);

                if (key === "d") {
                  result[key] = JSON.parse(result[key]); // d is already stringified and needs to be parsed.
                  // console.log(result[key]);
                }
              }

              if (key === "k" && !topicSearchResults) {
                const k = result[key].split(",");
                const kCount = k.filter((num) =>
                  synIndex.includes(parseInt(num) || 0)
                ).length;
                if (kCount > 0) {
                  result.r[key] = rScores[key] * kCount;
                  result.r.to += result.r[key];
                }
              }
              // console.log(result.s,result.r);
            });
            return true;
          } else return false;
        });
      });

    // console.log("defiant and matched results",tResults,matchResults);
    console.timeEnd(
      ">>>SearchXPath" + (topicSearchResults ? "-topic" : "-all")
    );
    // console.log("matchResults",JSON.stringify(matchResults));
    return matchResults;
  };

  const SearchTGIndex = (obj, searchValue, synIndex) => {
    const tggResults = [];
    const raScores = { d: 15, s: 10, t: 5, k: 3, g: 1 };
    const keywords = searchValue
      .toLowerCase()
      .split(" ")
      .map((word) => [word, pluralize(word), singularize(word)]);
    const flattenedKeywords = [].concat(...keywords);
    for (const key in obj) {
      if (typeof obj[key] === "object") {
        const nestedResults = SearchTGIndex(obj[key], searchValue, synIndex);
        tggResults.push(...nestedResults);
      } else if (key === "s" || key === "d" || key === "t" || key === "g") {
        let value = (key === "t" ? getTopicTitle(obj.t) : obj[key])
          .toString()
          .toLowerCase();
        if (key === "t") {
          obj.t = value + "|" + obj.t + "|" + getTitlePath(obj.t);
        }
        // value = JSON.stringify(value);
        // if(obj.t!==undefined && obj.g===undefined){
        //   obj.g = GetTggGuideline(obj).g;

        // }
        const wordCount = flattenedKeywords.filter((keyword) =>
          value.includes(keyword)
        ).length;
        if (wordCount > 0) {
          if (!obj.r) {
            obj.r = { to: 0, d: 0, s: 0, t: 0, k: 0, g: 0 };
          }
          if (key === "d") {
            let maxPercentage = 0;
            console.log(obj.d); //TODO...rank does not apply.
            for (const item of obj.d) {
              const itemValue = item.toString().toLowerCase();
              const itemWordCount = flattenedKeywords.filter((keyword) =>
                itemValue.includes(keyword)
              ).length;
              if (itemWordCount > 0) {
                const itemKeywordIndex = itemValue.indexOf(
                  flattenedKeywords.find((keyword) =>
                    itemValue.includes(keyword)
                  )
                );
                const itemPercentage =
                  itemKeywordIndex === 0
                    ? 100
                    : itemKeywordIndex > 0
                    ? Math.round(
                        (1 - itemKeywordIndex / itemValue.length) * 100
                      )
                    : 0;
                if (itemPercentage > maxPercentage) {
                  maxPercentage = itemPercentage;
                }
              }
            }
            obj.r[key] = (raScores[key] * maxPercentage) / 100;
            obj.r.to += obj.r[key];
            if (tggResults.length === 0) tggResults.push(obj);
          } else {
            const keywordIndex = value.indexOf(
              flattenedKeywords.find((keyword) => value.includes(keyword))
            );
            const percentage =
              keywordIndex === 0
                ? 100
                : keywordIndex > 0
                ? Math.round((1 - keywordIndex / value.length) * 100)
                : 0;

            obj.r[key] = (raScores[key] * wordCount * percentage) / 100;
            obj.r.to += obj.r[key];

            // Add Guideline name  and rank to result
            if (obj.g === undefined) {
              if (obj.t !== undefined) {
                obj.g = GetTggGuideline(obj).g.replace(/_/g, " ");
              } else {
                // console.log(obj);
                obj.g = GetTitleGuideline(obj).g.replace(/_/g, " ");
              }

              const wordCount = flattenedKeywords.filter((keyword) =>
                obj.g.includes(keyword)
              ).length;
              if (wordCount > 0) {
                const keywordIndex = obj.g.indexOf(
                  flattenedKeywords.find((keyword) => obj.g.includes(keyword))
                );
                const percentage =
                  keywordIndex === 0
                    ? 100
                    : keywordIndex > 0
                    ? Math.round((1 - keywordIndex / obj.g.length) * 100)
                    : 0;
                obj.r.g = (raScores.g * wordCount * percentage) / 100;
                obj.r.to += obj.r.g;
              }
            }
            if (tggResults.length === 0) tggResults.push(obj);
          }
        }
      } else if (key === "k") {
        const k = obj["k"].split(",");
        const kCount = k.filter((num) => synIndex.includes(num)).length;
        if (kCount > 0) {
          obj.r[key] = raScores[key] * kCount;
          obj.r.to += obj.r[key];
          if (tggResults.length === 0) tggResults.push(obj);
        }
      }
    }
    return tggResults;
  };

  const performSearch = async (dispatch, searchStore) => {
    // const searchIndex = searchStore.searchIndex;
    if (
      searchTerm === null ||
      searchTerm === undefined ||
      searchTerm.length < 3
    ) {
      dispatch(searchStore.resetResults("useEffect-searchTerm"));
      return;
    }

    let synIndex = [];

    let synonymSearchTerm = refineIndex.length > 0 ? refineIndex : searchIndex;
    console.time("tggSynonyms" + (refineIndex.length ? "-refine" : "-search"));
    synIndex = SearchTGSynonyms(synonymSearchTerm, tgg);
    console.timeEnd(
      "tggSynonyms" + (refineIndex.length ? "-refine" : "-search")
    );

    let searchKeyWords = synIndex.map((item) => {
      let row = tgg.synonyms.rows[item];
      let rowWords = row[0].split(", ");
      if (row.length > 1) {
        rowWords = rowWords.concat(row[1].split(", "));
      }
      return rowWords;
    });

    let allKeywordsArray = [];
    for (let i = 0; i < searchKeyWords.length; i++) {
      allKeywordsArray = allKeywordsArray.concat(searchKeyWords[i]);
    }

    let allKeywords = allKeywordsArray.join(" ").split(" ");
    allKeywords = allKeywords.concat(synonymSearchTerm.split(" "));
    allKeywords = allKeywords.filter((word) => {
      word = word.trim();
      return word.length > 0;
    });
    allKeywords = allKeywords.map((word) => word.toLowerCase());
    allKeywords = [...new Set(allKeywords)];

    setAllKeywords(allKeywords);

    let queryTerm = refineIndex.length > 0 ? refineIndex : searchIndex;

    let searchResults = { all: [], topics: [], drugs: [] };
    console.time("SearchTGTopics");
    searchResults.topics = await SearchXPath(queryTerm, synIndex, true);
    console.timeEnd("SearchTGTopics");

    searchResults.drugs = performDrugSearch(queryTerm, gSnapshot);
    searchResults.drugs = searchResults.drugs.flattedResults;

    console.time("SearchTGGuidelines");
    console.log(queryTerm, synIndex, false);
    searchResults.all = await SearchXPath(queryTerm, synIndex, false);
    console.timeEnd("SearchTGGuidelines");
    $(".loader").fadeOut("fast");
    SortByResults(dispatch, searchStore, searchResults);
  };

  const revertURL = () => {
    // const searchIndex = searchStore.searchIndex;
    const revertURL = "?appendedinputbuttons=" + searchIndex;
    window.history.replaceState(null, null, revertURL);
  };

  const goBack = () => {
    sessionStorage.removeItem("selectedGuideline");
    localStorage.removeItem("selectedGuideline");
    localStorage.removeItem("filterText");
    setWithinSearchVal("");
    dispatch(searchStore.setRefineIndex(""));
    dispatch(searchStore.setRefineFacet(""));
  };

  const highlightTextWithRegex = (htmlString, textsToHighlight) => {
    // console.time("highlight-results");
    // return htmlString;
    // Escape special characters in each string and join them into a single regex pattern
    // console.log(htmlString,textsToHighlight);
    const escapedTexts = textsToHighlight.map((text) =>
      text.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&")
    );
    const regexPattern = `(${escapedTexts.join("|")})`;
    const regex = new RegExp(regexPattern, "gi");

    // Replace the matched text with <mark> tags
    // return htmlString.replace(regex, '<mark>$1</mark>');
    // console.timeEnd("highlight-results");
    return (
      <span
        dangerouslySetInnerHTML={{
          __html: htmlString.replace(regex, "<mark>$1</mark>"),
        }}
      />
    );
  };

  useEffect(() => {
    // console.log("UE-sortResults");
    console.log(sortResults);

    dispatch(searchStore.setCurrentPage(1));

    const searchResults = {
      all: JSON.parse(JSON.stringify(searchAllResults)),
      topics: JSON.parse(JSON.stringify(searchTopicsResults)),
      drugs: JSON.parse(JSON.stringify(searchDrugResults)),
    };
    SortByResults(dispatch, searchStore, searchResults);
  }, [sortResults]);

  useEffect(() => {
    console.time("Created Snapshots");
    let snapshotsCompleted = 0;

    const checkSnapshotsReady = () => {
      snapshotsCompleted++;
      if (snapshotsCompleted === 2) {
        console.timeEnd("Created Snapshots");
        setSnapshotReady(1);
      }
    };

    defiant.getSnapshot(tgg.guidelines, (gsnapshot) => {
      setGSnapshot(gsnapshot);
      checkSnapshotsReady();
    });

    defiant.getSnapshot(tgg.topics, (tsnapshot) => {
      setTSnapshot(tsnapshot);
      checkSnapshotsReady();
    });

    displaySearch();
  }, []);

  useEffect(() => {
    // console.log("UE-snapshotReady");
    if (!snapshotReady) {
      if (searchTerm.length > 0) {
        // reset it to sent if when snapshot is ready.
        dispatch(searchStore.setSearchTerm(""));
      }
      return;
    }
    // console.log(">>snapShot",snapshotReady);

    // console.log("searchIndex",searchIndex);
    // console.log("searchTerm",searchTerm);
    const searchParams = new URLSearchParams(search);
    if (
      searchParams.has("appendedinputbuttons") ||
      searchParams.has("drugname")
    ) {
      const urlSearch =
        searchParams.get("appendedinputbuttons") ||
        searchParams.get("drugname") ||
        "";
      console.log(urlSearch);
      if (searchIndex === "") {
        dispatch(searchStore.setSearchIndex(urlSearch));
      }
      if (searchTerm === undefined || searchTerm === "") {
        dispatch(searchStore.setSearchTerm(urlSearch));
      }
    }

    $(".loader").fadeOut("slow"); // to show saved searches.
  }, [snapshotReady]);

  useEffect(() => {
    if (!snapshotReady) return;

    const inAsync = async () => {
      try {
        // Process topics facets
        const topicsFacetItems = await DefiantFacets(searchTopicsResults);
        const topicsFacetContent = await getGuidelinesFacet(
          topicsFacetItems,
          "searchTopicsResults"
        );
        setFacetTopicResults(topicsFacetContent);

        // Process drug facets
        const drugFacetItems = await DefiantFacets(searchDrugResults);
        const drugFacetContent = await getGuidelinesFacet(
          drugFacetItems,
          "searchDrugResults"
        );
        setFacetDrugResults(drugFacetContent);

        // Process all results facets
        const allFacetItems = await DefiantFacets(searchAllResults);
        const allFacetContent = await getGuidelinesFacet(
          allFacetItems,
          "searchAllResults"
        );
        setFacetAllResults(allFacetContent);
      } catch (error) {
        console.error("Error processing facets:", error);
      }
    };

    inAsync();
  }, [snapshotReady, searchTopicsResults, searchDrugResults, searchAllResults]);

  useEffect(() => {
    if (paginatePage === "topics") {
      PaginateMenu();
    } else if (paginatePage === "drugs") {
      PaginateDrug();
    } else if (paginatePage === "search") {
      PaginateSearch();
    } else {
      PaginateHome();
    }
  }, [paginatePage]);

  useEffect(() => {
    // console.log("UE-homeTabClass,menuTabClass,drugTabClass");
    if (!snapshotReady) return;

    if (homeTabClass === "active") {
      dispatch(searchStore.setFacets(facetAllResults));
      // console.log(facetAllResults);
    } else if (menuTabClass === "active") {
      dispatch(searchStore.setFacets(facetTopicResults));
      // console.log(facetTopicResults);
    } else if (drugTabClass === "active") {
      dispatch(searchStore.setFacets(facetDrugResults));
      // console.log(facetDrugResults);
    }

    // console.log("[homeTabClass,menuTabClass,drugTabClass]",homeTabClass,"|",menuTabClass,"|",drugTabClass);
    // console.log("[facetAllResults,facetTopicResults,facetTopicResults]",facetAllResults,"|",facetTopicResults,"|",facetDrugResults);

    // setTimeout(function() {
    //   window.scrollTo({top:100,behavior:'smooth'});
    // }, 100);
    dispatch(searchStore.setCurrentPage(1));
  }, [homeTabClass, menuTabClass, drugTabClass]);

  useEffect(() => {
    // console.log("UE-facetAllResults,facetTopicResults,facetTopicResults");
    if (!snapshotReady) return;

    if (homeTabClass === "active") {
      dispatch(searchStore.setFacets(facetAllResults));
      // console.log(facetAllResults);
    } else if (menuTabClass === "active") {
      dispatch(searchStore.setFacets(facetTopicResults));
      // console.log(facetTopicResults);
    } else if (drugTabClass === "active") {
      dispatch(searchStore.setFacets(facetDrugResults));
      // console.log(facetDrugResults);
    }

    // console.log("[homeTabClass,menuTabClass,drugTabClass]",homeTabClass,"|",menuTabClass,"|",drugTabClass);
    // console.log("[facetAllResults,facetTopicResults,facetTopicResults]",facetAllResults,"|",facetTopicResults,"|",facetDrugResults);

    // setTimeout(function() {
    //   window.scrollTo({top:100,behavior:'smooth'});
    // }, 100);
    dispatch(searchStore.setCurrentPage(1));
  }, [facetAllResults, facetTopicResults, facetTopicResults]);

  const DefiantFacets = async (results) => {
    console.time("buildFacetsDefiant");
    const facets = defiant.getFacets(results, {
      guideline: { group: "*", key: "g" },
    });
    if (facets.guideline) delete facets.guideline[0];
    // delete facets.guideline.Other;
    // console.log(facets);
    console.timeEnd("buildFacetsDefiant");
    return facets;
  };

  useEffect(() => {
    // console.log("UE-searchTerm");
    if (!snapshotReady) return;
    // $(".loader").fadeIn("slow");
    console.log(
      "searchIndex",
      searchIndex,
      "/",
      "searchTerm",
      searchTerm,
      "/",
      "refineIndex",
      refineIndex
    );
    setDrugTabShow(true);
    resultItemRefs.current = [];
    const URLpath = window.location.host;
    $("title").text("Search Results - Therapeutic Guidelines");
    $("#topic-banner").text("Search Results");
    $("#tocbox").css("display", "none");

    const searchParams = new URLSearchParams(search);
    if (searchParams.has("appendedinputbuttons")) {
      const urlSearch = searchParams.get("appendedinputbuttons");
      if (searchIndex === "") {
        dispatch(searchStore.setSearchIndex(urlSearch));
      }
      const urlGuideline = searchParams.get("guideline");
      if (urlSearch !== "" || urlSearch.length > 0 || urlGuideline === null) {
        // localStorage.setItem('headerSearch', urlSearch);
        if (urlGuideline === null || urlGuideline === "null") {
          localStorage.removeItem("selectedGuideline");
          sessionStorage.removeItem("selectedGuideline");
        } else {
          sessionStorage.setItem("selectedGuideline", urlGuideline);
        }
        // tg(urlGuideline);
        setTimeout(() => {
          performSearch(dispatch, searchStore);
        }, 1000);
        localStorage.removeItem("filterText");

        $(".loader").fadeOut("slow");
      }
    } else {
      $(".loader").fadeOut("slow"); // to show saved searches.
    }

    return () => {
      // clearProcessedResults();
      localStorage.removeItem("filterText");
      dispatch(updateState({ cache: {} }));
      dispatch(searchStore.setCurrentPage(1));
    };
  }, [searchTerm]);

  useEffect(() => {
    console.log("refineIndex", refineIndex);

    if (!snapshotReady) return;

    setTimeout(() => {
      performSearch(dispatch, searchStore);
    }, 1000);
  }, [refineIndex]);

  useEffect(() => {
    // console.log("UE-refineFacet");
    if (!snapshotReady) return;

    if (refineFacet.length === 0) {
      PaginateSearch();
      setTimeout(() => {
        performSearch(dispatch, searchStore);
      }, 1000);
      // tg(refineFacet);
      return;
    }

    let refineTopics = searchTopicsResults.filter((result) => {
      return result.g === refineFacet;
    });
    let refineDrugs = searchDrugResults.filter((result) => {
      return result.g === refineFacet;
    });
    let refineAll = searchAllResults.filter((result) => {
      return result.g === refineFacet;
    });
    dispatch(
      searchStore.setResults({
        topicResults: refineTopics,
        drugResults: refineDrugs,
        allResults: refineAll,
      })
    );
  }, [refineFacet]);

  useEffect(() => {
    console.log("withinSearchVal, shouldGoBack");
    if (!withinSearchVal && shouldGoBack) {
      filteredArr = [];
      if (
        getURL.indexOf("powerappsportals") > -1 ||
        getURL.indexOf("tg.org.au") > -1
      ) {
        let initTG = setInterval(function () {
          try {
            tgg = window.tgg;
            clearInterval(initTG);
            setTimeout(() => {
              performSearch(dispatch, searchStore);
            }, 1000);
          } catch (e) {}
        }, intVariable);
      } else {
        setTimeout(() => {
          performSearch(dispatch, searchStore);
        }, 1000);
        // tg(urlGuideline);
      }
      // getTG(resultsF, genSyn, synKy);
      // getTopicTG(resultsF);
      revertURL();
      setDrugTabShow(true);
      setShouldGoBack(false);
      const facetListItems = document.querySelectorAll(
        "#facetList li a.active-gl"
      );
      facetListItems.forEach((item) => {
        item.classList.remove("active-gl");
      });
    }
  }, [withinSearchVal, shouldGoBack]);

  let showFacets = true;

  if (
    searchAllResults.length === 0 &&
    searchTopicsResults.length === 0 &&
    searchDrugResults.length === 0
  ) {
    showFacets = false;
  }

  let pagingList = searchAllResults;
  if (homeTabClass === "active") {
    pagingList = searchAllResults;
  } else if (menuTabClass === "active") {
    pagingList = searchTopicsResults;
  } else if (drugTabClass === "active") {
    pagingList = searchDrugResults;
  }

  return (
    <div id="tgsearch">
      <Suspense fallback={<div className="loader"></div>}>
        <NavBar push={navigate} setWithinSearchVal={setWithinSearchVal} />
        <TopicBanner pathname={pathname} search={search} push={navigate} />
        <SavedSearchModal />
        <div className="container">
          <div className="loader"></div>
          <div className="row container">
            <div className="col-md-4 columnBlockLayout searchContainer">
              <h4 className="section-heading hidden-xs">Sort by</h4>
              <SortResults
                sortResults={sortResults}
                setSortResults={setSortResults}
              />
              <h4 className="section-heading hidden-xs">Refine search</h4>
              <div className="form-group">
                <RefineSearch />
                <a
                  className="slider-arrow hide"
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                >
                  <i className="flaticon-double30"></i>
                </a>
                <div
                  className="tree-menu refine-container"
                  id="sidemenu-container"
                >
                  <div id="facet-container" className="facet-container">
                    <h5 className="tgFacetHeader">
                      <strong>View Results by Guidelines</strong>
                    </h5>
                    <ul id="facetList" className="list-unstyled refine-search ">
                      {showFacets ? searchFacets : ""}
                    </ul>
                    <div className="row">
                      <div className="borderBottom visible-xs"></div>
                      <div className="col-lg-7 col-sm-7 col-xs-7">
                        <a
                          href="#"
                          title="Save search"
                          data-toggle="modal"
                          data-backdrop="static"
                          data-target="#savSearch"
                          id="saveSearchBtn"
                          className="btn btn-inverse btn-block whiteBgXS2"
                        >
                          Save search
                        </a>
                      </div>
                    </div>
                    <div id="recentSearchDiv">
                      <div>
                        <h4 className="section-heading mTop30px">
                          My saved searches
                        </h4>
                        <ul className="recent-searches"></ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-8 columnBlockLayout tabContainer ">
              <h4 className="section-heading noBtmMarging noBtmPadding mTop6px">
                Search results
              </h4>
              <div className="row result-container">
                {/* DEKSTOP VIEW */}
                <div className="col-md-12 filter-desktop">
                  <span className="enlarge filter-view">
                    View results by:&nbsp;
                  </span>
                  <span
                    title="Shows any content that includes your search term(s)."
                    onClick={() => PaginateHome()}
                    className="enlarge filter-text"
                  >
                    <a
                      data-toggle="tab"
                      href="#home"
                      aria-expanded="true"
                      id="allResultsCtr"
                      className={`search-view-tab allResultsCtr ${homeLinkClass}`}
                    >{`All Results (${searchAllResults.length})`}</a>
                  </span>
                  &nbsp;
                  <span
                    title="Shows only the main topic headings that include your search term(s)."
                    onClick={() => PaginateMenu()}
                    className="enlarge filter-text"
                  >
                    <a
                      data-toggle="tab"
                      href="#menu1"
                      aria-expanded="true"
                      id="topicResultsCtr"
                      className={`search-view-tab topicResultsCtr ${menuLinkClass}`}
                    >{`Topic Results (${searchTopicsResults.length})`}</a>
                  </span>
                  &nbsp;
                  {drugTabShow && (
                    <span
                      title="If your search term is a drug in Therapeutic Guidelines, this shows a list of links straight to the full dosing information."
                      onClick={() => PaginateDrug()}
                      className="active enlarge filter-text"
                    >
                      <a
                        data-toggle="tab"
                        href="#drug"
                        aria-expanded="true"
                        id="drugIndCtr"
                        className={`search-view-tab drugIndCtr ${drugLinkClass}`}
                      >{`Drug Indication (${searchDrugResults.length})`}</a>
                    </span>
                  )}
                </div>

                {/* MOBILE VIEW */}
                <div className="filter-mobile">
                  <div
                    title="Shows any content that includes your search term(s)."
                    onClick={() => PaginateHome()}
                    className="enlarge filter-text"
                  >
                    <a
                      data-toggle="tab"
                      href="#home"
                      aria-expanded="true"
                      id="allResultsCtr"
                      className={`search-view-tab allResultsCtr ${homeLinkClass}`}
                    >{`All Results (${searchAllResults.length})`}</a>
                  </div>
                  &nbsp;
                  <div
                    title="Shows only the main topic headings that include your search term(s)."
                    onClick={() => PaginateMenu()}
                    className="enlarge filter-text"
                  >
                    <a
                      data-toggle="tab"
                      href="#menu1"
                      aria-expanded="true"
                      id="topicResultsCtr"
                      className={`search-view-tab topicResultsCtr ${menuLinkClass}`}
                    >{`Topic Results (${searchTopicsResults.length})`}</a>
                  </div>
                  &nbsp;
                  {drugTabShow && (
                    <div
                      title="If your search term is a drug in Therapeutic Guidelines, this shows a list of links straight to the full dosing information."
                      onClick={() => PaginateDrug()}
                      className="active enlarge filter-text"
                    >
                      <a
                        data-toggle="tab"
                        href="#drug"
                        aria-expanded="true"
                        id="drugIndCtr"
                        className={`search-view-tab drugIndCtr ${drugLinkClass}`}
                      >{`Drug Indication (${searchDrugResults.length})`}</a>
                    </div>
                  )}
                </div>
                {(refineIndex.length > 0 || refineFacet.length > 0) && (
                  <div id="btnBackResults" className="col-md-12">
                    <h5>
                      <span>«</span>
                      <a
                        id="returnAllResults"
                        href="#"
                        className="noRPaddingIP"
                        onClick={() => goBack()}
                      >
                        <strong>Back to all results</strong>
                      </a>
                    </h5>
                  </div>
                )}
              </div>
              <div id="searching" className={`tab-pane ${searchingTabClass}`}>
                <span className="dot"></span>
              </div>
              <div id="home" className={`tab-pane ${homeTabClass}`}>
                {homeTabClass === "active" ? (
                  <SearchResultsAll
                    snapshot={gSnapshot}
                    tsnapshot={tSnapshot}
                    results={searchAllResults}
                    highlight={highlightTextWithRegex}
                    allkeywords={allKeywords}
                  />
                ) : (
                  <NoResults />
                )}
              </div>
              <div id="menu1" className={`tab-pane ${menuTabClass}`}>
                {menuTabClass === "active" ? (
                  <SearchResultsTopics
                    results={searchTopicsResults}
                    snapshot={tSnapshot}
                    gsnapshot={gSnapshot}
                    highlight={highlightTextWithRegex}
                    allkeywords={allKeywords}
                  />
                ) : (
                  <NoResults />
                )}
              </div>
              {drugTabShow && (
                <div id="drug" className={`tab-pane ${drugTabClass}`}>
                  {drugTabClass === "active" ? (
                    <SearchResultsDrugs
                      results={searchDrugResults}
                      snapshot={gSnapshot}
                      tsnapshot={tSnapshot}
                      highlight={highlightTextWithRegex}
                      allkeywords={allKeywords}
                    />
                  ) : (
                    <NoResults />
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
        <Paging
          resultcount={pagingList.length}
          tab1={homeTabClass}
          tab2={menuTabClass}
          tab3={drugTabClass}
        />
        <div className="modal fade" id="savSearch" role="dialog">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  className="close"
                >
                  <span aria-hidden="true">×</span>
                </button>
                <h4 className="modal-title">Save search</h4>
              </div>
              <div className="modal-body">
                <div className="form-group">
                  <input
                    type="text"
                    name="searchname"
                    id="searchName"
                    placeholder="Enter a name"
                    className="form-control"
                  />
                </div>
              </div>
              <div className="modal-footer saveSearch-footer">
                <input
                  type="button"
                  id="searchOkBtn"
                  name="searchOk"
                  value="Ok"
                  className="btn btn-info borderNone"
                />
                <input
                  type="button"
                  value="Cancel"
                  id="cancelSaveSearch"
                  data-dismiss="modal"
                  className="btn btn-default noborder"
                />
              </div>
            </div>
          </div>
        </div>
        <TopicToolsSticky pathname={pathname} />

        {$(".dxp-footer").length === 0 && (
          <>{!window.Microsoft && <Footer />}</>
        )}
      </Suspense>
    </div>
  );
};

export default Search;
